import React from 'react';
import MatchEventListItem from '../list/MatchEventListItem';

/**
 * MatchEvent - Renders an individual match event
 */
function MatchEvent({
  match,
  onEventClick,
  onDeleteClick,
  disabled
}) {
  return (
    <MatchEventListItem
      event={match}
      onClick={onEventClick}
      onDelete={onDeleteClick}
      disabled={disabled}
    />
  );
}

export default React.memo(MatchEvent);
